import { useEffect, useState } from 'react';

import { isUserAccessAllowed } from '@ce-cfbdigital/cgl-cfb-fe-foundation';
import PubSub from 'pubsub-js';

import { oktaAuth } from '../../auth';
import { updateSessionStorage } from '../../utilities';
import { AUTO_OPEN_ACCOUNT_MODAL_PAGES } from '../constants';

const useModalAndGlobalNav = (isRegionalAccount, location) => {
  const [isAccountModalOpen, setIsAccountModalOpen] = useState(false);
  const [isRegionModalOpen, setIsRegionModalOpen] = useState(false);
  const [isGlobalNavExpanded, setIsGlobalNavExpanded] = useState(false);

  const handleAccountModal = () => {
    setIsAccountModalOpen(!isAccountModalOpen);
    if (isRegionModalOpen) setIsRegionModalOpen(false);
    if (isGlobalNavExpanded) setIsGlobalNavExpanded(false);
  };

  const handleRegionCloseModal = () => {
    setIsRegionModalOpen(!isRegionModalOpen);
    if (isAccountModalOpen) setIsAccountModalOpen(false);
    if (isGlobalNavExpanded) setIsGlobalNavExpanded(false);
  };

  const handleGlobalNavigation = () => {
    setIsGlobalNavExpanded(!isGlobalNavExpanded);
  };

  const checkPermission = async () => {
    const { roles = [] } = AUTO_OPEN_ACCOUNT_MODAL_PAGES.find(item => location.includes(item.page)) || { roles: [] };
    const hasAccess = roles.length && (await isUserAccessAllowed(oktaAuth, { roles }));

    return !!hasAccess;
  };

  useEffect(async () => {
    const isPageForOpeningModal = await checkPermission();
    const isRegAccConfirmed = updateSessionStorage.getItem('isRegionalAccountConfirmed');
    if (isRegionalAccount && isPageForOpeningModal && !isRegAccConfirmed) {
      setIsAccountModalOpen(true);
    }
  }, [isRegionalAccount]);

  useEffect(() => {
    PubSub.subscribe('isRegionalAccountConfirmed', (_msg, isRegAccConfirmed) => {
      updateSessionStorage.setItem('isRegionalAccountConfirmed', isRegAccConfirmed);
    });
  }, []);

  return {
    isAccountModalOpen,
    isRegionModalOpen,
    handleAccountModal,
    handleRegionCloseModal,
    isGlobalNavExpanded,
    handleGlobalNavigation
  };
};

export default useModalAndGlobalNav;
